<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(unitPrice)="data">
        {{ formatAmount(data.item.unitPrice) }}
      </template>

      <template v-slot:cell(amount)="data">
        {{ formatAmount(data.item.amount) }}
      </template>

      <template v-slot:cell(remarks)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: "ApmsRegThinningBaggingDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'greenhouseNo', label: '大棚编号', width: '120px'},
        {key: 'treeCount', label: '种植棵数', width: '110px'},
        {key: 'quantity', label: '数量（串）', width: '130px'},
        {key: 'feeItemName', label: '费项名称', width: '150px'},
        {key: 'unitPrice', label: '单价', width: '100px'},
        {key: 'priceUnit', label: '单位', width: '80px'},
        {key: 'amount', label: '金额（元）', width: '110px'},
      ],
      items: [],
    }
  },
  created() {
    const data = this.$route.query.data
    if (data) {
      this.items = JSON.parse(data)
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) {
        return '0.00'
      }
      return num.toFixed(2)
    },
    showDetail(content) {
      if (!content) {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
</style>
